// extracted by mini-css-extract-plugin
module.exports = {"toggleCart":"ToggleCart_toggleCart__ri95G","focus-visible":"ToggleCart_focus-visible__U4GBt"};